// auto-load.js — remplace les boutons "Voir plus" par un scroll infini.
//
// Strategie : on laisse la logique de pagination existante dans chaque fichier
// (design-home.js, salle.js, artistes.js) intacte. On se contente de masquer
// le bouton via CSS et de declencher .click() programmatique des que son
// conteneur parent entre dans le viewport (rootMargin 800px pour pre-charger).
//
// Avantage : aucune modification des fichiers metier, diff minimal.
(function(){
'use strict';

const TARGETS = ['#load-more', '#v-load-more', '#v-arch-load-more', '#artistes-load-more'];

if (!('IntersectionObserver' in window)) return;

const wired = new WeakSet();

function observe(btn){
  if (!btn || wired.has(btn)) return;
  const anchor = btn.parentElement || btn;
  wired.add(btn);
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      // Le parent est visible (display != none) — on declenche le click.
      // Les handlers existants gerent l'increment de page + renderGrid().
      if (anchor.offsetParent !== null) btn.click();
    });
  }, { rootMargin:'800px 0px', threshold:0 });
  io.observe(anchor);
}

function wireAll(){
  TARGETS.forEach(sel => observe(document.querySelector(sel)));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wireAll);
} else {
  wireAll();
}
// Certaines pages ne montent leurs boutons qu'apres fetch async. Retry pour capter.
setTimeout(wireAll, 1200);
setTimeout(wireAll, 3500);
})();
